import { jsx as _jsx } from "react/jsx-runtime";
// AICopilotDiffView.tsx
import React, { useMemo } from 'react';
import { diffWordsWithSpace } from 'diff';
/**
 * Converts HTML into structured text.
 * Supports tables, lists, paragraphs, and line breaks.
 */
export const htmlToStructuredText = (html) => {
    if (!html)
        return '';
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    // 1. Process tables (add separators to cells, insert line breaks)
    doc.querySelectorAll('th, td').forEach((el) => {
        el.insertAdjacentText('beforeend', '  |  ');
    });
    doc.querySelectorAll('tr').forEach((el) => {
        el.insertAdjacentText('afterend', '\n');
    });
    doc.querySelectorAll('table').forEach((el) => {
        el.insertAdjacentText('afterend', '\n\n');
    });
    // 2. Process list items
    doc.querySelectorAll('li').forEach((el) => {
        el.insertAdjacentText('afterend', '\n');
    });
    // 3. Process block elements
    doc.querySelectorAll('p, h1, h2, h3, h4, h5, h6, div, blockquote').forEach((el) => {
        el.insertAdjacentText('afterend', '\n\n');
    });
    // 4. Process manual line breaks
    doc.querySelectorAll('br').forEach((el) => {
        el.insertAdjacentText('afterend', '\n');
    });
    return (doc.body.textContent || '').trim();
};
export const AICopilotDiffView = ({ originalHtml = '', suggestionHtml = '' }) => {
    const diffResult = useMemo(() => {
        if (!originalHtml || !suggestionHtml)
            return null;
        const structuredOriginal = htmlToStructuredText(originalHtml);
        const structuredSuggestion = htmlToStructuredText(suggestionHtml);
        return diffWordsWithSpace(structuredOriginal, structuredSuggestion);
    }, [originalHtml, suggestionHtml]);
    if (!diffResult)
        return null;
    return (_jsx("div", { className: "diff-view", style: { whiteSpace: 'pre-wrap', lineHeight: '1.5em' }, children: diffResult.map((part, index) => {
            if (part.added) {
                return (_jsx("span", { className: "bg-success-subtle text-success font-weight-bold px-1 rounded", style: { backgroundColor: '#d4edda', color: '#155724' }, children: part.value }, index));
            }
            if (part.removed) {
                return (_jsx("span", { className: "bg-danger-subtle text-danger text-decoration-line-through px-1 rounded opacity-75 me-1", style: { backgroundColor: '#f8d7da', color: '#721c24', textDecoration: 'line-through' }, children: part.value }, index));
            }
            return _jsx("span", { children: part.value }, index);
        }) }));
};
